import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-landing-faqs',
  templateUrl: './landing-faqs.component.html',
  styleUrls: ['./landing-faqs.component.scss'],
})
export class LandingFaqsComponent implements OnInit {
  destroy$: Subject<any>;
  selectedOption = {
    name: 'Instalación',
    faqs: [
      {
        question: '¿Cómo agendo la instalación?',
        answer:
          'Una vez realizada tu suscripción un agente comercial se pondrá en contacto con usted para agendar fecha y horario. La misma podría ser en un plazo de 2 semanas',
        open: false,
      },
      {
        question: '¿Cuánto tardan en instalar el equipo?',
        answer:
          'La instalación puede durar entre 30-45 minutos aproximadamente.',
        open: false,
      },
      {
        question: '¿Puedo cambiar mi cita de instalación?',
        answer:
          'Sí, podés reprogramar tu cita de instalación con 24 a 48 horas de anticipación a través de WhatsApp (postventa).',
        open: false,
      },
      {
        question: '¿Qué incluye tu suscripción?',
        answer:
          'La instalación cuenta con:\n El equipo dispenser de tu preferencia con instalación.\n Conexiones y manguera necesaria de 1.50 metros, siempre que se cumplan con los requisitos básicos de instalación para no generar un trabajo adicional.\n Conexión eléctrica.\n Cambio de filtros cada 12 meses.',
        open: false,
      },
      {
        question:
          '¿Se puede instalar el dispenser en otra parte que no sea la cocina?',
        answer:
          'Si, se puede instalar en cualquier lugar que tenga las especificaciones necesarias exceptuando espacios exteriores.',
        open: false,
      },
    ],
  };
  options = [
    {
      name: 'Instalación',
      faqs: [
        {
          question: '¿Cómo agendo la instalación?',
          answer:
            'Una vez realizada tu suscripción un agente comercial se pondrá en contacto con usted para agendar fecha y horario. La misma podría ser en un plazo de 2 semanas',
          open: false,
        },
        {
          question: '¿Cuánto tardan en instalar el equipo?',
          answer:
            'La instalación puede durar entre 30-45 minutos aproximadamente.',
          open: false,
        },
        {
          question: '¿Puedo cambiar mi cita de instalación?',
          answer:
            'Sí, podés reprogramar tu cita de instalación con 24 a 48 horas de anticipación a través de WhatsApp (postventa).',
          open: false,
        },
        {
          question: '¿Qué incluye tu suscripción?',
          answer:
            'Tu suscripción incluye el equipo en comodato, el servicio de mantenimiento y la reposición de filtros cada 12 meses, además de la atención técnica ante cualquier eventualidad.',
          open: false,
        },
        {
          question:
            '¿Se puede instalar el dispenser en otra parte que no sea la cocina?',
          answer:
            'Si, se puede instalar en cualquier lugar que tenga las especificaciones necesarias exceptuando espacios al intemperie.',
          open: false,
        },
      ],
    },
    {
      name: 'Formas de contacto',
      faqs: [
        {
          question: '¿Cómo me puedo contactar para contratar el servicio?',
          answer:
            'Podes realizar la auto gestión a través del portal o con el sector de ventas a través de WhatsApp',
          open: false,
        },
        {
          question:
            '¿Cómo me contacto si ya soy cliente y quiero adquirir un nuevo producto?',
          answer:
            'Puedes solicitar el nuevo equipo a través de Mi Perfil o contactarte a través de WhatsApp',
          open: false,
        },
        {
          question: '¿Cómo puedo contactarme con el servicio técnico?',
          answer:
            'Trabajamos para brindarte el mejor servicio, contáctate con nuestro centro de atención al cliente a través de WhatsApp, mail o teléfono.',
          open: false,
        },
        {
          question: '¿Me puedo contactar a través de WhatsApp?',
          answer:
            'Por supuesto, haz click en el icono que se encuentra en la parte de abajo a la derecha.',
          open: false,
        },
      ],
    },
    {
      name: 'Cambio de domicilio',
      faqs: [
        {
          question: '¿Tiene algún costo el cambio de domicilio?',
          answer:
            'Junto con tu suscripción podrá realizar un cambio de domicilio por año sin ningún cargo extra.',
          open: false,
        },
        {
          question: '¿Cómo es la gestión a realizar en caso de mudanza?',
          answer:
            'Podrás comunicarte con Atención al cliente para coordinar un día y horario para realizar el cambio de domicilio.\n Considerá comunicarte con 15 días de anticipación.',
          open: false,
        },
      ],
    },
   /*  {
      name: 'Promociones',
      faqs: [
        {
          question: '¿Para qué sirven los puntos?',
          answer:
            'Con los puntos Everfull podrás recibir descuentos en tu suscripcion',
          open: false,
        },
        {
          question: '¿Cómo consigo puntos?',
          answer:
            'Tus puntos se suman por pagos a tiempo y no tener deudas, tambien si tenes referidos',
          open: false,
        },
        {
          question:
            '¿Para qué sirve el código de recomendación y cómo se cuál es el mio?',
          answer:
            'Con el código de recomendación podrás enviarselo a tus conocidos y obtener beneficios por cada uno que se suscriba. Además, ellos tendrán una bonificación en su nueva suscripción. Podrás conocer tu código de recomendación en "Mi Perfil" una vez que crees tu cuenta.',
          open: false,
        },
      ],
    }, */
  ];

  constructor(private store: Store<AppState>) {
    this.destroy$ = new Subject<any>();
  }

  ngOnInit(): void {
    this.store
      .select('landing')
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        const { FAQS } = state;
        console.log(FAQS);
      });
    this.selectedOption = this.options[0];
  }
}
